<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" sm="6" md="6">
        <v-text-field
          v-model="item.name"
          :label="$t('global.name')"
          type="text"
        />
      </v-col>
      <v-col cols="12" sm="6" md="6">
        <v-combobox
          v-if="serviceSelectItems"
          v-model="item.services"
          :items="serviceSelectItems"
          :no-data-text="$t('global.no_result')"
          :placeholder="$t('global.no_select')"
          clearable
          :label="$t('service.services')"
          item-text="name"
          item-value="@id"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex';
import { mapFields } from 'vuex-map-fields';

export default {
  name: 'ProcessSchemaFilter',
  props: {
    values: {
      type: Object,
      required: true
    }
  },
  data() {
    return {};
  },
  mounted() {
      this.serviceGetSelectItems();
  },

  computed: {
    // eslint-disable-next-line
    item() {
      return this.initialValues || this.values;
    },
    ...mapFields('service', {
      serviceSelectItems: 'selectItems',
    }),

  },
  methods: {
    ...mapActions({
      serviceGetSelectItems: 'service/fetchSelectItems',

    }),
  }
};
</script>
